import {
  ButtonColor,
  PageCreateInput,
  PageUpdateInput,
  QuestionCreateInput,
  RelatedPageCreateInput,
  RelatedPageUpdateInput,
} from "../../api";
import { builder } from "../builder";

const buttonColor = builder.string().oneOf(Object.values(ButtonColor));

const Question = builder.input<QuestionCreateInput>("QuestionCreateInput", {
  question: builder.string().required(),
});

const RelatedPage = builder.input<RelatedPageCreateInput>("RelatedPageCreateInput", {
  name: builder.string().nullable(),
  targetPage: builder.string().required(),
  color: buttonColor.nullable(),
});

const RelatedPageUpdate = builder.input<RelatedPageUpdateInput>("RelatedPageUpdateInput", {
  _destroy: builder.boolean(),
  id: builder.string().uuid(),
  name: builder.string(),
  targetPage: builder.string(),
  color: buttonColor.nullable(),
});

builder.input<PageCreateInput>("PageCreateInput", {
  name: builder.string().required(),
  content: builder.array().required(),
  parrent: builder.string().nullable(),
  questions: builder.array().of(Question).nullable(),
  relatedPages: builder.array().of(RelatedPage).nullable(),
  image: builder.string().uuid().nullable(),
});

builder.input<PageUpdateInput>("PageUpdateInput", {
  name: builder.string().nullable(),
  content: builder.array().nullable(),
  parrent: builder.string().nullable(),
  questions: builder.array().of(Question).nullable(),
  relatedPages: builder.array().of(RelatedPageUpdate).nullable(),
  image: builder.string().uuid().nullable(),
});
